import React, { useRef, memo } from 'react';
import PropTypes from 'prop-types';
import { Editor } from '@splashthat/splash-cms-engine';
import { WebRenderer } from 'common/components/TouchpointEditor/renderer/WebRenderer';
import { BLOCKS } from 'common/components/TouchpointEditor/constants/blocks';
import Workspace from 'common/components/Workspace';
import { stateSubsetForEquality } from 'common/components/TouchpointEditor/utils/stateSubsetForEquality';
import TopBar from './TopBar';
import GenericConfirmation from './GenericConfirmation';

const GenericConfirmationContainer = memo(({ goToConfirmationsSettings, initialTree, confirmationsState }) => {
    const portal = useRef(null);

    return (
        <Editor
            editing
            portal={portal}
            initialTree={initialTree}
            blocks={BLOCKS}
            Renderer={WebRenderer}
            stateSubsetForEquality={stateSubsetForEquality}
        >
            <Workspace.Topbar>
                <TopBar goToConfirmationsSettings={goToConfirmationsSettings} confirmationsState={confirmationsState} />
            </Workspace.Topbar>
            <Workspace.Content>
                <React.Suspense fallback={null}>
                    <GenericConfirmation portal={portal} />
                </React.Suspense>
            </Workspace.Content>
        </Editor>
    );
});

GenericConfirmationContainer.propTypes = {
    goToConfirmationsSettings: PropTypes.func.isRequired,
    initialTree: PropTypes.object.isRequired,
    confirmationsState: PropTypes.string.isRequired,
};

export default GenericConfirmationContainer;
